import React from 'react';
import { connect } from 'react-redux';

import * as types from './modal-types';
import UploadChartModal from './upload-chart-modal';

const MODAL_COMPONENTS = {
  [types.UPLOAD_CHART_MODAL]: UploadChartModal,
}

const RootModal = ({ 
  modalType, 
  modalProps 
}) => {
  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType]
  return (
    <SpecificModal {...modalProps} />
  );
}

const mapStateToProps = state => state.modal;
export default connect(mapStateToProps)(RootModal)


// WEBPACK FOOTER //
// ./src/components/modal/root-modal.js